<div class="tab-container">
  <div class="ft-form-row">
    <span class="title">{{ title }}</span>
  </div>

  <div class="ft-form-row col1-v100">
    <div class="ft-form-input">
      <div class="icon-input-container">
        <input class="icon-input" placeholder="{{ 'ph_search_source' | translate }}" type="text"
          [(ngModel)]="searchPhrase" />
        <div class="icon-input-wrap">
          <img src="/assets/images/icons/search.svg" width="30" height="30" />
        </div>
      </div>
    </div>
  </div>

  <div class="source-wrapper">
    <div class="tab-forms">
      <div id="sources-content">
        <div class="ft-form" *ngIf="sources?.length == 0 || sources == null">
          <div class="ft-form-row no-record-row">
            <div class="no-record">
              <span>{{ "lbl_no_source" | translate }}</span>
            </div>
          </div>
        </div>

        <div id="source-list-container" #sourceListContainer *ngIf="sources?.length > 0">
          <div *ngFor="let source of getFilteredSources()" class="item"
          [ngClass]="{ 'highlighted-place': editedSourceId === source.id }">
            <div class="item-image">
              <img [src]="source?.mediaUrl || '/assets/images/icons/source.svg'"/>
            </div>

            <div class="item-content">
              <span class="label-m-grey text-ellipsis-1">
                {{ source.title }}
              </span>
              <span class="label-s-grey text-ellipsis-1">({{ source.used }}x)</span>
            </div>

            <div class="item-options">
              <img src="/assets/images/icons/edit.svg" class="ft-btn-round-green-base" width="23" height="23"
                (click)="editSource(source)" />
              <img src="/assets/images/icons/delete.svg" class="ft-btn-round-green-base" width="23" height="23"
                (click)="deleteSource(source.id)" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>